import { Check, Plus, Trash2 } from "lucide-react";
import { Button } from "../../../../components/ui/common/button";

interface IngredientDraftActionsProps {
  saved: boolean;
  canSave: boolean;
  canRemove: boolean;
  isSaving: boolean;
  onSave: () => void;
  onSaveAndAddNew: () => void;
  onRemove: () => void;
}

const IngredientDraftActions = ({
  saved,
  canSave,
  canRemove,
  isSaving,
  onSave,
  onSaveAndAddNew,
  onRemove
}: IngredientDraftActionsProps) => {
  if (saved) {
    return (
      <div
        className="tw-h-9 tw-w-9 tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-bg-primary/10 tw-text-primary"
        title="Saved"
        aria-label="Saved"
      >
        <Check className="tw-h-4 tw-w-4" />
      </div>
    );
  }

  return (
    <div className="tw-flex tw-h-9 tw-shrink-0 tw-items-center tw-justify-end tw-gap-1.5">
      <Button
        type="button"
        size="icon"
        className="tw-h-9 tw-w-9"
        onClick={onSave}
        disabled={!canSave || isSaving}
        title="Save"
        aria-label="Save"
      >
        <Check className="tw-h-4 tw-w-4" />
      </Button>
      <Button
        type="button"
        size="icon"
        variant="secondary"
        className="tw-h-9 tw-w-9"
        onClick={onSaveAndAddNew}
        disabled={!canSave || isSaving}
        title="Save & Add New"
        aria-label="Save and add new ingredient"
      >
        <Plus className="tw-h-4 tw-w-4" />
      </Button>
      <Button
        type="button"
        size="icon"
        variant="ghost"
        className="tw-h-9 tw-w-9 tw-text-destructive hover:tw-text-destructive hover:tw-bg-destructive/10"
        onClick={onRemove}
        disabled={!canRemove || isSaving}
        title="Remove"
        aria-label="Remove"
      >
        <Trash2 className="tw-h-4 tw-w-4" />
      </Button>
    </div>
  );
};

export default IngredientDraftActions;
